export const devBasicAuth = {
  username: "test",
  password: "password",
};
export const supportNumber = "9721108108";
export const defaultCountryCodeAndMobileLength = "+91_10";
export const mapUrl = "https://www.google.com/maps?q=";

export const fourtyFiveDays = 45;

export const PAGE_SIZE = 15;

export const durgapurCoordinates = {
  latitude: 23.55,
  longitude: 87.32,
};

export const socialPlatformLinks = {
  instagram: "https://www.instagram.com/globalneuroandspinecare/",
  facebook: "https://www.facebook.com/globalneuroandspinecare",
  youtube: "https://www.youtube.com/@globalneuroandspinecare",
  linkedin:
    "https://www.linkedin.com/in/global-neuro-and-spine-care-418969229/",
  twitter: "https://x.com/GlobalNSCare",
};

export const appLinks = {
  android: "https://play.google.com/store/apps/details?id=com.globalneuro.care",
  ios: "https://apps.apple.com/in/app/global-neuro-spine-care/id6737462963",
};

export const webLink = "https://globalneuroandspinecare.com";

export const seo = {
  home: {
    title: "Global Neuro and Spine Care",
    description:
      "India’s trusted neuro care platform. Book top neurologists, get patient updates, order medicines, and schedule diagnostic tests—seamlessly from your home with Global Neuro & Spine Care.",
    keywords:
      "Global Neuro and Spine Care, back pain, brain tumor symptoms, neurologist near me, online doctor consultation, medicine delivery app, spine surgery India, best neurosurgeon in India, neuro care",
  },
  findDoctor: {
    title:
      "Find Verified Neurosurgeons, Neurologists & Spine Specialists in India | Global Neuro and Spine Care",
    description:
      "Find top neurosurgeons, neurologists, and spine specialists on Global Neuro and Spine Care. Book online consultations and access advanced treatments for brain, spine, and nerve conditions.",
    keywords:
      "best neurosurgeon near me, top neurologist in India, spine specialist West Bengal, brain tumor surgeon India, migraine treatment, sciatica specialist, verified neurosurgeons India, online neuro consultation",
  },
  medicines: {
    title:
      "Order Affordable Neuro Medicines Online | Global Neuro and Spine Care",
    description:
      "Order neuro medicines online from Global Neuro and Spine Care. Fast doorstep delivery, verified pharmacies, affordable pricing. Upload prescription for epilepsy, brain & spine medicine delivery.",
    keywords:
      "buy medicine online, home delivery medicine, instant medicine delivery, online medicine delivery, verified neuro pharmacy, neuro medicines India, epilepsy medicine online, affordable brain medicines",
  },
  tests: {
    title: "Book Neuro Diagnostic Tests",
    description:
      "Book MRI, CT, EEG, NCS, and other neuro tests online with Global Neuro and Spine Care. Get affordable labs, no upfront fees, fast reports. Trusted diagnostics platform for brain and spine care.",
    keywords:
      "MRI brain scan, CT spine, EEG test, NCV test near me, nerve conduction test, neuro diagnostics India, brain test booking, radiology center near me, diagnostic center India, 1.5T MRI, neuro scan online",
  },
  aboutUs: {
    title:
      "Global Neuro and Spine Care | Best Neuro & Spine Care Platform India",
    description:
      "Global Neuro and Spine Care is India’s trusted neuro healthtech platform. Connect with top neurosurgeons, access advanced treatments, and get brain and spine care from verified experts.",
    keywords:
      "best neurosurgeon in India, neurologist online consultation, neuro healthtech platform, verified neuro doctors, brain and spine care India, affordable neuro treatments, top neurologists near me",
  },
  partnerWithUs: {
    title:
      "Join as a Verified Neuro Doctor | Global Neuro and Spine Care Platform",
    description:
      "Join Global Neuro and Spine Care – India’s leading neuro healthtech platform. Partner with us to grow your neuro practice, reach online patients, and deliver advanced brain & spine care.",
    keywords:
      "join neuro healthtech platform, verified neurosurgeons India, neurologist partnership India, spine surgeon consultation, grow neuro practice, online neuro doctor, brain specialist India, GNSC doctor panel",
  },
  faq: {
    title: "FAQs | Global Neuro & Spine Care Help Center",
    description:
      "Find quick answers to FAQs about doctors, appointments, video consultations, medicines, lab tests, health records, and patient support at Global Neuro & Spine Care.",
    keywords:
      "faqs, global neuro and spine care help center, doctor consultation faqs, appointment faqs, medicine order faqs, diagnostic test faqs, health records help, patient support questions, neuro care support, online doctor faqs, spine care faqs, brain care help, app support questions, healthcare faqs",
  },
};
